// First-party analytics — real events only, fired only after cookie consent ("accepted").
// Stored server-side in MongoDB; admin dashboard reads GET /api/admin/analytics.
import api from "./api";
import { CONSENT_KEY } from "./googleAds";

function sessionId() {
  let sid = sessionStorage.getItem("zjz_sid");
  if (!sid) {
    sid = `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;
    sessionStorage.setItem("zjz_sid", sid);
  }
  return sid;
}

function detectSource() {
  const params = new URLSearchParams(window.location.search);
  const utm = params.get("utm_source");
  if (utm) return utm;
  const ref = document.referrer || "";
  if (!ref) return "direct";
  try {
    const host = new URL(ref).hostname;
    if (host.includes("google")) return "google";
    if (host.includes("instagram")) return "instagram";
    if (host.includes("facebook")) return "facebook";
    if (host.includes("vinted")) return "vinted";
    if (host === window.location.hostname) return "direct";
    return host;
  } catch {
    return "direct";
  }
}

export function trackEvent(type, extra = {}) {
  if (localStorage.getItem(CONSENT_KEY) !== "accepted") return;
  api.post("/track", {
    type,
    path: window.location.pathname,
    source: detectSource(),
    device: window.innerWidth < 768 ? "mobile" : "desktop",
    sid: sessionId(),
    ...extra,
  }).catch(() => {});
}
